import {
  PanelLeft,
  PanelBottom,
  SunMoon,
  Settings,
  LogOut,
  RefreshCw,
  ZoomIn,
  ZoomOut,
  Maximize2,
} from 'lucide-react';
import { useAppStore } from '@/stores/app-store';
import { useModalStore } from '@/stores/modal-store';
import { apiClient } from '@/api/client';
import type { Command } from '../types';

/**
 * UI and app-lifecycle commands. These are always applicable — no `when()`
 * guards — because they act on the app shell itself, not on a focused tab.
 */
export const uiCommands: Command[] = [
  {
    id: 'ui.toggle-sidebar',
    label: 'Toggle Sidebar',
    icon: PanelLeft,
    category: 'UI',
    shortcut: 'Ctrl+B',
    keywords: ['panel', 'left', 'hide'],
    run: () => useAppStore.getState().toggleSidebar(),
  },
  {
    id: 'ui.toggle-bottom-panel',
    label: 'Toggle Bottom Panel',
    icon: PanelBottom,
    category: 'UI',
    shortcut: 'Ctrl+J',
    keywords: ['log', 'history', 'hide'],
    run: () => useAppStore.getState().toggleBottomPanel(),
  },
  {
    id: 'ui.toggle-theme',
    label: 'Toggle Theme (Dark / Light)',
    icon: SunMoon,
    category: 'UI',
    keywords: ['dark', 'light', 'color', 'mode'],
    run: () => useAppStore.getState().toggleTheme(),
  },
  {
    id: 'ui.open-settings',
    label: 'Open Settings',
    icon: Settings,
    category: 'UI',
    keywords: ['preferences', 'config', 'options'],
    run: () => useModalStore.getState().openSettings(),
  },
  {
    id: 'ui.zoom-in',
    label: 'Zoom In',
    icon: ZoomIn,
    category: 'UI',
    keywords: ['bigger', 'larger'],
    run: () => {
      const z = parseFloat(document.documentElement.style.zoom || '1');
      document.documentElement.style.zoom = String(Math.min(2, z + 0.1));
    },
  },
  {
    id: 'ui.zoom-out',
    label: 'Zoom Out',
    icon: ZoomOut,
    category: 'UI',
    keywords: ['smaller'],
    run: () => {
      const z = parseFloat(document.documentElement.style.zoom || '1');
      document.documentElement.style.zoom = String(Math.max(0.5, z - 0.1));
    },
  },
  {
    id: 'ui.zoom-reset',
    label: 'Reset Zoom',
    icon: Maximize2,
    category: 'UI',
    keywords: ['100%', 'actual size'],
    run: () => {
      document.documentElement.style.zoom = '1';
    },
  },
  {
    id: 'app.reload',
    label: 'Reload DBGo',
    icon: RefreshCw,
    category: 'Help',
    keywords: ['refresh', 'restart'],
    run: () => window.location.reload(),
  },
  {
    id: 'auth.signout',
    label: 'Sign Out',
    icon: LogOut,
    category: 'Help',
    keywords: ['logout', 'exit'],
    run: () => apiClient.logout(),
  },
];
